import React from 'react';
import { motion } from 'framer-motion';

const KarriereSection = () => {
  return (
    <section className="py-20 bg-black text-white relative overflow-hidden">
      {/* Abstract graphic elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none overflow-hidden">
        <div className="absolute top-[20%] left-[10%] w-96 h-96 rounded-full border-2 border-[#00C2CC]"></div>
        <div className="absolute top-[30%] right-[5%] w-64 h-64 rounded-full border-2 border-[#00C2CC] opacity-30"></div>
        <div className="absolute bottom-[10%] left-[15%] w-48 h-48 rounded-full border-2 border-[#00C2CC] opacity-60"></div>
        
        <div className="absolute top-[10%] right-[20%] w-40 h-40">
          <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <rect x="10" y="10" width="80" height="80" stroke="#00C2CC" strokeWidth="2" />
          </svg>
        </div>
        
        <div className="absolute bottom-[30%] left-[40%] w-60 h-60">
          <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <path d="M10,10 L90,10 L90,90 L10,90 Z" stroke="#00C2CC" strokeWidth="2" />
          </svg>
        </div>
        
        <div className="absolute top-[50%] left-[25%] w-32 h-32">
          <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <polygon points="50,10 90,90 10,90" stroke="#00C2CC" strokeWidth="2" />
          </svg>
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-5">Werden Sie Teil der Zukunft von YADE Home</h2>
            <p className="text-gray-300 text-lg mb-8">
              Wir sind stets auf der Suche nach talentierten und motivierten Menschen, die mit uns die Immobilienwelt von morgen gestalten möchten.
              Bei YADE Home GmbH bieten wir ein dynamisches Arbeitsumfeld, in dem Innovation und Zusammenarbeit im Mittelpunkt stehen.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex flex-col md:flex-row items-center justify-center gap-8"
          >
            <div className="flex-1 bg-gray-900 p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4">Warum YADE Home?</h3>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start">
                  <div className="mr-3 mt-1">
                    <svg className="w-5 h-5 text-[#00C2CC]" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <span>Innovatives und zukunftsorientiertes Unternehmen</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1">
                    <svg className="w-5 h-5 text-[#00C2CC]" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <span>Vielfältige Entwicklungsmöglichkeiten</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1">
                    <svg className="w-5 h-5 text-[#00C2CC]" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <span>Flache Hierarchien und kollegiales Umfeld</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-3 mt-1">
                    <svg className="w-5 h-5 text-[#00C2CC]" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <span>Moderne Arbeitsbedingungen und flexible Arbeitszeiten</span>
                </li>
              </ul>
            </div>

            <div className="flex-1 bg-gray-900 p-8 rounded-lg">
              <h3 className="text-xl font-bold mb-4">Aktuelle Positionen</h3>
              <ul className="space-y-4 text-gray-300">
                <li>
                  <h4 className="font-medium">Immobilienberater (m/w/d)</h4>
                  <p className="text-sm text-gray-400">Vollzeit · Köln</p>
                </li>
                <li>
                  <h4 className="font-medium">Projektmanager (m/w/d)</h4>
                  <p className="text-sm text-gray-400">Vollzeit · Köln, Mönchengladbach</p>
                </li>
                <li>
                  <h4 className="font-medium">Marketing Spezialist (m/w/d)</h4>
                  <p className="text-sm text-gray-400">Teilzeit möglich · Köln</p>
                </li>
              </ul>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-12 text-center"
          >
            <a 
              href="#"
              className="inline-block bg-[#00C2CC] hover:bg-[#00a0a8] text-white px-8 py-3 rounded-full font-medium text-lg transition-colors duration-300"
            >
              Offene Stellen ansehen
            </a>
            <p className="mt-6 text-gray-400">
              Initiativbewerbungen sind jederzeit willkommen unter <a href="mailto:karriere@yade-home.de" className="text-[#00C2CC] hover:underline">karriere@yade-home.de</a>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default KarriereSection;
